var map = {
	"./IMG_0283.JPG": 6381,
	"./IMG_2785.JPG": 7232,
	"./IMG_7532-min.png": 8421,
	"./bubble2-min.jpg": 5618,
	"./bubble3-min.PNG": 472,
	"./bubble4-min.png": 5864,
	"./bubble5-min.jpg": 8617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6254;